import React from 'react';
import {
  Grid,
  Typography,
  TextField,
} from "@mui/material";
import Box from '@mui/material/Box';
import Button from "../../components/Button";
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useLoginResponseMutation } from "../../reducer/loginReducer";
import CircularLoader from "../../components/loader";

const Login = ({ handleClick, handleLogin }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [errormsg, setErrormsg] = React.useState('')
  const [data, setData] = React.useState({
    email: "123456789", // Hardcoded email
    password: "123456789", // Hardcoded password
  });

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  const handleChange = (event) => {
    setErrormsg('')
    const name = event.target.name;
    const value = event.target.value;
    setData((values) => ({ ...values, [name]: value }));
  };

  const loginapicall = () => {
    if (data.password && data.email)
      loginApi()
  }

  const [
    loginResponse,
    { isLoading, isSuccess, isError, isFetching, error, data: responseData },] = useLoginResponseMutation();

  async function loginApi() {
    const paramsData = {
      userName: data.email,
      password: data.password
    };

    try {
      const response = await loginResponse({ paramsData });

      if (response.data) {
        localStorage.setItem("token", response?.data?.token);
        console.log(response?.data?.token,"token")
        setErrormsg('')
        handleLoginClick();
      }
      else if (response.error) {
        setErrormsg(response.error.data.message)
      }
    } catch (err) {
      console.log("error", err);
    }
  }

  const handleLoginClick = () => {
    handleLogin(true)
  }

  return (
    <>
    {/* {isLoading && <CircularLoader position="loaderMiddle"></CircularLoader>} */}
    <Box className='signup_container'
      sx={{
        boxShadow: "0px 1px 6px #00000015",
        borderRadius: '9px',
        padding: '6%',
        width: '60%',
        marginTop: '13%',
        background: "#FFFFFF",
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
      }}
    >

      <Typography sx={{ color: '#000000', letterSpacing: '0.22px', fontWeight: '600', fontSize: '36px', fontfamily: 'Rubik' }} component="h1" variant="h5">
        Log In
      </Typography>
      <Typography sx={{ color: '#888888', letterSpacing: '0.09px', fontfamily: 'Rubik' }} component="h1" >
        Log In to your account
      </Typography>
      <Box component="form" noValidate sx={{ mt: 3 }}>
        <label htmlFor="name" style={{ color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
          Email ID
        </label>
        <TextField
          required
          fullWidth
          id="email"
          value={data.email}
          onChange={handleChange}
          placeholder='Enter your email ID here'
          style={{ fontFamily: 'Rubik', marginTop: '4px', fontWeight: 'normal', paddingBottom: '8%' }}
          name="email"
          autoComplete="email"
          autoFocus
        />
        <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
          Password
        </label>
        <TextField
          required
          placeholder='Enter your password'
          fullWidth
          id="password"
          value={data.password}
          onChange={handleChange}
          style={{ fontFamily: 'Rubik', fontWeight: 'normal', marginTop: '4px', paddingBottom: '13px' }}
          name="password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  style={{ color: '#0D5C75' }}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '7%' }}>
          <Typography style={{ marginLeft: '34%', color: 'red', fontSize: '13px' }}>{errormsg}</Typography>
          <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '1%' }}>
            <Button
              color="green"
              opacity="1"
              name="Log In"
              onClick={loginapicall}
            />
          </Grid>
        </Grid>

        <Grid style={{ marginLeft: '26%', marginTop: '11%', display: 'flex', }}>
          <a href="#" onClick={event => handleClick(false)} style={{ color: '#0D5C75', fontSize: '18px', fontfamily: 'Rubik', fontWeight: 'bold',textDecoration:'underline 1px solid #0D5C75' }}>
            Click here
          </a>
         
          <Typography
            style={{ marginLeft: '8px', fontfamily: 'Rubik' }}>
            to Sign Up
          </Typography>
        </Grid>
      </Box>
    </Box>
    </>
  )
}

export default Login;
